import { Message } from 'element-ui';

const suffixToAcceptMap = {
  doc: [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  pdf: ['application/pdf'],
  xls: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ],
  mp4: ['video/mp4'],
  jpg: ['image/jpg', 'image/jpeg'],
  jpeg: ['image/jpg', 'image/jpeg'],
  png: ['image/png'],
  txt: ['text/plain'],
  zip: ['application/x-zip-compressed', 'application/zip'],
  rar: ['application/x-rar-compressed', 'application/rar'],
};


export default {
  async checkFile(file, options) {
    const finalOptions = Object.assign(
      {},
      {
        noToast: false,
        size: undefined, // 10M
        acceptErrorMsg: '', // 类型错误文案
      },
      options,
    );
    let error = '';
    if (finalOptions.accept) {
      // 允许的文件格式
      const allowAcceptList = [];
      Object.keys(suffixToAcceptMap).forEach((key) => {
        if (!finalOptions.accept) return;
        if (finalOptions.accept.indexOf(key) > -1) {
          allowAcceptList.push(...suffixToAcceptMap[key]);
        }
      });
      if (allowAcceptList.length && allowAcceptList.indexOf(file.type) === -1) {
        error = finalOptions.acceptErrorMsg || '文件类型不符合要求';
        if (!finalOptions.noToast) Message.error(error);
        return error;
      }
    }
    if (finalOptions.size) {
      if (file.size > finalOptions.size) {
        const sizeText =
          finalOptions.size >= 1024 * 1024
            ? `${finalOptions.size / 1024 / 1024}M`
            : `${finalOptions.size / 1024}K`;
        error = `文件大小超出限制，请上传小于${sizeText}的文件！`;
        if (!finalOptions.noToast) Message.error(error);
        return error;
      }
    }

    return '';
  },
  async checkFileList(fileList, options) {
    const checkPromiseAll = [];

    fileList.forEach((file) => {
      checkPromiseAll.push(this.checkFile(file, Object.assign({}, { noToast: true }, options)));
    });

    const errorList = await Promise.all(checkPromiseAll);

    const error = errorList.find(err => err);
    if (error) {
      if (!options.noToast) Message.error(error);
      return error;
    }

    return '';
  },
};



// WEBPACK FOOTER //
// ./src/services/check-service.js